import { Route, Routes } from 'react-router';
import { registerTile } from '../../tiles/registry';
import { registerWebModule } from '../registry';
import { copy } from './copy';
import { GoalScreen } from './screens/GoalScreen';
import { WeightDashboard } from './screens/WeightDashboard';
import { CurrentWeightTile, WeightGoalTile, WeightTrendTile } from './tiles/WeightTiles';
import { WeightIcon } from './WeightIcon';

/** Mounted by ModuleRoute at /m/weight/*, so these paths are relative. */
function WeightScreen() {
  return (
    <Routes>
      <Route index element={<WeightDashboard />} />
      <Route path="log" element={<WeightDashboard startLogging />} />
      <Route path="goal" element={<GoalScreen />} />
    </Routes>
  );
}

registerWebModule({
  id: 'weight',
  navLabel: copy.navLabel,
  Icon: WeightIcon,
  Screen: WeightScreen,
});

registerTile({
  type: 'weight.current',
  moduleId: 'weight',
  title: 'Weight',
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  defaultOnToday: true,
  Component: CurrentWeightTile,
});

registerTile({
  type: 'weight.trend',
  moduleId: 'weight',
  title: 'Weight trend',
  sizes: ['wide', 'small'],
  defaultSize: 'wide',
  Component: WeightTrendTile,
});

registerTile({
  type: 'weight.goal',
  moduleId: 'weight',
  title: 'Weight goal',
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: WeightGoalTile,
});
